<app-loading-indicator *ngIf="loadingData; else wrapper"></app-loading-indicator>

<ng-template #wrapper>
  <div
    *ngIf="channels.length == 0; else usersTable"
    class="empty-state--stations"
    data-testId="users-empty-state"
  >
  </div>
</ng-template>

<ng-template #usersTable>
  <div *ngIf="dataSource.filteredData.length > 0; else searchEmptyState" class="channels-table-container  pt-3"
    data-testId="channels-table">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" style="background: transparent;">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-testId="channel-name-header">
          Station Name
        </th>
        <td data-testId="channel-name" mat-cell *matCellDef="let element" class="channel-name">
          {{ element.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="logo_id">
        <th mat-header-cell *matHeaderCellDef>Logo</th>
        <td mat-cell *matCellDef="let element" class="channel-logo">
          <img data-testId="channel-logo" [src]="getLogoSrc(element.logo_id)" class="channel-logo-image"
            alt="channel-logo-preview" [matTooltip]="element.name" matTooltipClass="channel-logo-tooltip" />
        </td>
      </ng-container>

      <ng-container matColumnDef="stream_source">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-testId="channel-address-header">
          Stream Address
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="channel-address-wrapper">
            <div class="channel-address" [ngClass]="{ 'assign-mode': assignMode }" data-testId="channel-address">
              {{ element.stream_source || 'N/A' }}
            </div>
            <mat-icon *ngIf="element.stream_source" class="channel-address-icon" [matTooltip]="element.stream_source"
              matTooltipClass="channel-address-tooltip">
              visibility
            </mat-icon>
          </div>
      </ng-container>

      <ng-container matColumnDef="provider">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-testId="channel-provider-header">
          Provider
        </th>
        <td data-testId="channel-provider" mat-cell *matCellDef="let element">
          {{ element.is_external ? element.provider : 'Internal' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="menu">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex">
            <button mat-button mat-stroked-button class="schedule-button" data-testId="edit-program-guide-button"
              (click)="openEditProgramGuideDialog(element)">
              <div class="schedule-button__wrapper">
                <div class="material-symbols-outlined schedule-button__icon">
                  calendar_clock
                </div>
                <div class="schedule-button__label-container">
                  <div class="schedule-button__top-label">
                    {{ element.is_external ? 'View' : 'Edit' }}
                  </div>
                  <div>Schedule</div>
                </div>
              </div>
            </button>
            <button data-testId="channel-menu-button" mat-icon-button (click)="$event.stopPropagation()"
              [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button *ngIf="!element.is_external" data-testId="delete-channel-button" mat-menu-item
                (click)="openChannelsDialog('delete-channel', element)">
                <mat-icon>delete</mat-icon>
                <span> Delete Station</span>
              </button>
              <button data-testId="edit-channel-button" mat-menu-item
                (click)="openChannelsDialog('edit-channel', element)">
                <mat-icon>edit</mat-icon>
                <span> Edit Station</span>
              </button>
            </mat-menu>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'assign-mode': assignMode, highlighted: selection.isSelected(row) }" (click)="setSelection(row)">
      </tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="5">No data matching the filter</td>
      </tr>
    </table>
    <mat-paginator #paginator *ngIf="dataSource && dataSource.filteredData.length" class="channels-paginator"
      (page)="handlePageEvent($event)" [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions"
      aria-label="Select page" data-testId="channels-table-paginator"></mat-paginator>
  </div>
</ng-template>

<ng-template #searchEmptyState>
  <div *ngIf="dataSource.filteredData.length == 0" class="channels-search-empty-state" data-testId="search-empty-state">
  </div>
</ng-template>
